import { useMemo } from 'react'
import { useAppStore } from '@core/store'
import { nomeDoModelo, type NomeDoModelo } from './nomeDoModelo'

/** O nome curto de cada modelo aberto, pelo modelId, e se há mais de um.
 *
 *  Regra para um só modelo: o painel de propriedades mostra sempre o
 *  modelo (é uma linha, e é lá que se vai identificar um elemento); as
 *  etiquetas compactas (passagem do rato, barra do 3D, navegação da
 *  selecção, colunas da comparação) só o mostram com vários modelos,
 *  porque com um só não há ambiguidade e o espaço é pouco. */
export function useNomesDosModelos(): {
  nomeDe: (modelId: string) => NomeDoModelo | null
  varios: boolean
} {
  const models = useAppStore((s) => s.models)
  return useMemo(() => {
    const porId = new Map(models.map((m) => [m.id, nomeDoModelo(m, models)]))
    return { nomeDe: (id: string) => porId.get(id) ?? null, varios: models.length > 1 }
  }, [models])
}
